import React from 'react';
import styled from 'styles/styled-components';
import translations from 'translations';
import { formatVND } from 'containers/QuickOrder/utils';
import messages from './messages';

interface ResultFooterProps {
  totalAmount: number;
  selectedCount: number;
  onReanalyzeClick: () => void;
  onAddToCart: () => void;
}

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow:
    0 1px 0 rgba(0, 0, 0, 0.05),
    0 4px 32px rgba(0, 0, 0, 0.08),
    0 -1px 0 #f2f3f5;
  padding: 20px 10px;
  z-index: 1002;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 768px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TotalLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #111827;
`;

const TotalValue = styled.span`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: #111827;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
`;

const BaseButton = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  font-family: inherit;
  padding: 10px 16px;
  transition:
    opacity 0.2s,
    background 0.2s;
`;

const OutlinedButton = styled(BaseButton)`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  color: #111827;

  &:hover {
    background: #f9fafb;
  }
`;

const FilledButton = styled(BaseButton)<{ disabled: boolean }>`
  background: ${({ disabled }) => (disabled ? '#D1D5DB' : '#43A047')};
  border: none;
  color: #fff;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    background: ${({ disabled }) => (disabled ? '#D1D5DB' : '#3C9041')};
  }
`;

const ResultFooter = ({ totalAmount, selectedCount, onReanalyzeClick, onAddToCart }: ResultFooterProps) => {
  const addLabel = selectedCount
    ? translations(messages.footerAddToCart).replace('{count}', String(selectedCount))
    : translations(messages.footerAddToCartDisable);
  const disabled = selectedCount === 0;
  return (
    <Container>
      <Inner>
        <TotalRow>
          <TotalLabel>{translations(messages.footerTotalLabel)}</TotalLabel>
          <TotalValue>{formatVND(totalAmount)}</TotalValue>
        </TotalRow>
        <ButtonRow>
          <OutlinedButton type="button" onClick={onReanalyzeClick}>
            {translations(messages.footerReanalyze)}
          </OutlinedButton>
          <FilledButton type="button" disabled={disabled} onClick={disabled ? undefined : onAddToCart}>
            {addLabel}
          </FilledButton>
        </ButtonRow>
      </Inner>
    </Container>
  );
};

export default ResultFooter;
